module.exports = __webpack_public_path__ + "static/media/small_ship.8803cde0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameSpacePort/small_ship.png
// module id = 2482
// module chunks = 0